import AmountForm from "../../components/deposit/amount-form";
import { connect } from "react-redux";
import { getDeposit } from "../../selectors";
import { setDepositAmount } from "../../actions/deposit";
import { withRouter } from "react-router-dom";

function select(state) {
  return {
    deposit: getDeposit(state)
  };
}

export default connect(select, { setDepositAmount: setDepositAmount })(withRouter(AmountForm));
